import { css } from '@emotion/react';
import { type FC } from 'react';
import {
  getLogoSource, type LogoVersion,
} from '~/_shared/components/logo/logo.helpers';

const wrapperStyle = ({ width }: { width: string}) => css({
  width,
});

const logoStyle = css({
  display: 'block',
  width: '100%',
  height: 'auto',
});

type LogoProps = Readonly<{
  className?: string;
  logoVersion?: LogoVersion;
  width: string;
}>;

export const LogoComponent: FC<LogoProps> = ({ className, logoVersion, width }: LogoProps) => (
  <div
    css={wrapperStyle({ width })}
    className={className}
  >
    <img
      css={logoStyle}
      src={getLogoSource(logoVersion)}
      alt="Company logo"
      className={className}
    />
  </div>
);
